// src/components/ui/Interruptor.js
// Interruptor (switch) de encendido/apagado, global y reusable (Toto, 08/10/2026: "¿no sería mejor un tipo switch? algo
// más intuitivo"). Reemplaza el par de botones "Encender / Apagar": ahí el botón morado marcaba lo elegido, pero se leía
// como "lo que va a hacer si lo tocás". Acá el estado se ve de un vistazo: perilla a la derecha y pista verde =
// encendido; a la izquierda y gris = apagado, siempre con el texto al lado (nunca solo el color).
//
// Uso:
//   <Interruptor valor={activo} onChange={setActivo} etiqueta="Lumi para todos" />
//
// Props:
//   valor            — true = encendido.
//   onChange(nuevo)  — recibe el valor contrario al tocarlo (también con Espacio o Enter: es un <button role="switch">).
//   etiqueta         — qué enciende, para los lectores de pantalla (no se muestra: el título va al lado, en la pantalla).
//   textoEncendido / textoApagado — el texto al lado ('Encendido' / 'Apagado' por defecto).
//   cambiado         — true: borde morado de "todavía no está guardado" (cuando el cambio espera un botón Guardar).
//   peligro          — true: encendido se pinta ROJO, no verde. Para lo que al encenderse FRENA algo (los cierres de
//                      pedidos: encendido = ya no entran pedidos; Toto, 08/10/2026). El resto, verde.
//   deshabilitado    — no se puede tocar (mientras se guarda, sin permiso…).
//   id, title, style — opcionales.
//
// Estilos en globals.css (F.3 `.interruptor`), con tokens: se ve bien en claro y en oscuro.
// 🔴 En una pantalla con botón Guardar, tocarlo NO guarda: solo cambia lo que se va a guardar. Marcar `cambiado` y poner
//    `<SinGuardar />` al lado (export de este mismo archivo), para que se note (ESTETICA_GUIA §3.4.3).
import React from 'react';

export default function Interruptor({
  valor, onChange, etiqueta, textoEncendido = 'Encendido', textoApagado = 'Apagado', cambiado = false,
  peligro = false, deshabilitado = false, id, title, style,
}) {
  const encendido = !!valor;
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={encendido}
      aria-label={etiqueta}
      title={title}
      disabled={deshabilitado}
      onClick={() => { if (onChange) onChange(!encendido); }}
      className={`interruptor${encendido ? ' encendido' : ''}${cambiado ? ' cambiado' : ''}${peligro ? ' peligro' : ''}`}
      style={style}
    >
      <span className="interruptor-pista" aria-hidden="true">
        <span className="interruptor-perilla" />
      </span>
      <span>{encendido ? textoEncendido : textoApagado}</span>
    </button>
  );
}

/**
 * Etiqueta "Sin guardar" que va al lado de un interruptor con `cambiado` (la misma del faro, Lumi → Ajustes):
 *   {cambiado && <SinGuardar />}<Interruptor … cambiado={cambiado} />
 * `title` cambia el texto de ayuda cuando el botón de guardar no se llama "Guardar".
 */
export function SinGuardar({ title = 'Todavía no está guardado: se guarda con el botón Guardar' }) {
  return <span className="interruptor-sin-guardar" title={title}>Sin guardar</span>;
}
